<template>
  <base-floating-card>
    <div id="event-remove-location-card">
      <remove-location-from-event-art class="art" />
      <div id="heading-and-buttons">
        <h5 id="remove-location-heading">
          Remove {{ locationName }} from this event?
        </h5>
        <div id="remove-location-buttons">
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'x'"
            @click="close"
          />
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'checkmark'"
            @click="confirm"
          />
        </div>
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";
import RoundButtonWithIcon from "../../RoundButtonWithIcon.vue";
import RemoveLocationFromEventArt from "../../Illustrations/RemoveContactFromEvent.vue";
export default {
  data() {
    return {
      processing: false,
    };
  },
  computed: {
    locationName() {
      if (this.location) {
        switch (this.location.api_version) {
          case "9-28-2022":
            return this.location.Name ? this.location.Name : "this location";
          default:
            return this.location.name ? this.location.name : "this location";
        }
      } else {
        return "this location";
      }
    },
  },
  methods: {
    close() {
      if (!this.processing) {
        this.$emit("close");
      }
    },
    async confirm() {
      this.processing = true;
      let payload = {
        event: this.event,
        location: this.location,
      };
      //   todo : hasn't been created yet, so do that. also, create the lambda, then, clean the kitchen, bitch
      await this.$store.dispatch("removeLocationFromEvent", payload);
      this.processing = false;
      this.close();
    },
  },
  created() {},
  components: {
    BaseFloatingCard,
    RoundButtonWithIcon,
    RemoveLocationFromEventArt,
  },
  props: ["location", "event"],
};
</script>
<style scoped>
#event-remove-location-card {
  display: flex;
  justify-content: space-between;
  padding: 50px;
}

.art {
  height: 75px;
  margin-right: 70px;
}

#heading-and-buttons {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#remove-location-buttons {
  display: flex;
  width: 100px;
  justify-content: space-between;
}
</style>
